import { render, staticRenderFns } from "./withdrawalOverview.vue?vue&type=template&id=5fd2025e&scoped=true"
import script from "./withdrawalOverview.vue?vue&type=script&lang=js"
export * from "./withdrawalOverview.vue?vue&type=script&lang=js"
import style0 from "./withdrawalOverview.vue?vue&type=style&index=0&id=5fd2025e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2025e",
  null
  
)

export default component.exports